import axios from '../http'
import viewUI from 'view-design'
import 'view-design/dist/styles/iview.css'

function getCurDate(type) {

  var date = new Date();
  var seperator1 = "-";
  var seperator2 = ":";
  var month = date.getMonth() + 1;
  var strDate = date.getDate();
  if (month >= 1 && month <= 9) {
    month = "0" + month;
  }
  if (strDate >= 0 && strDate <= 9) {
    strDate = "0" + strDate;
  }
  if (type == 1) {
    var currentdate = date.getFullYear() + seperator1 + month + seperator1 + strDate + " " + date.getHours() + seperator2 +
      date.getMinutes();
    return currentdate;
  } else {
    var currentdate = date.getFullYear() + seperator1 + month + seperator1 + strDate;
    // + " " + date.getHours() + seperator2 + date.getMinutes()
    // + seperator2 + date.getSeconds();
    return currentdate;
  }


}

function CheckImgExists(imgurl) {
  return new Promise(function (resolve, reject) {
    var ImgObj = new Image(); //判断图片是否存在
    ImgObj.src = imgurl;
    ImgObj.onload = function (res) {
      resolve(res);
    }
    ImgObj.onerror = function (err) {
      reject(err)
    }
  })
}

function exportExcelPost(url, param, excelTitle, excelName, excelKey) {
  viewUI.Spin.show({
    render: (h) => {
      return h('div', [
        h('Icon', {
          'class': 'demo-spin-icon-load',
          props: {
            type: 'ios-cloud-download',
            size: 38
          }
        }),
        h('div', '文件下载中')
      ])
    }
  })
  param['length'] = -1
  axios.post(url, param).then(back => {
    var res = {
      data: [],
      success: false
    }
    res['data'] = back['data'] || back
    res['success'] = back['success'] || true
    viewUI.Spin.hide();
    if (res.data.length == 0) {
      viewUI.Message.error('未查询到数据')
      return false;
    }
    if (res.success) {
      var jsonData = res.data
      if (url.indexOf('news/newsExport') > -1) {
        jsonData.map(function (val, index) {
          val['newsurl'] = ''
          val['itemList'] = val['itemList'].join('、')
          val['showtime'] = val['showtime'].split('.0')[0]
          var url = 'https://app.wjdaily.com:9906/jwj/web.html?id=' + val['guid']
          val['newsurl'] = url
          return val
        })
      }
      console.log(jsonData, 'jsonData')

    } else {
      viewUI.Message.error(res.msg)
    }
  })
}

function exportExcel(url, param, excelTitle, excelName, excelKey) {
  console.log(viewUI, Viewer)

  viewUI.Spin.show({
    render: (h) => {
      return h('div', [
        h('Icon', {
          'class': 'demo-spin-icon-load',
          props: {
            type: 'ios-cloud-download',
            size: 38
          }
        }),
        h('div', '文件下载中')
      ])
    }
  });
  param['length'] = -1
  axios.get(url, {
    params: param
  }).then(back => {
    console.log(back, 'res')
    var res = {
      data: [],
      success: false
    }
    res['data'] = back['data'] || back
    res['success'] = back['success'] || true
    viewUI.Spin.hide();
    if (res.data.length == 0) {
      viewUI.Message.error('未查询到数据')
      return false;
    }
    if (res.success) {
      var jsonData = res.data
      if (url.indexOf('honortj/getHonorBySchool') > -1) {
        jsonData.map(function (val, index) {
          val['starnum'] = val['fivestar'] + '/' + val['fourstar']
          for (var key in val) {
            if (key.indexOf('item') > -1) {
              val[key] = val[key].split('@')[0]
            }
          }
        })
      }
      if (url.indexOf('student/getQueryList') > -1) {
        jsonData.map(function (val, index) {
          val['gclassname'] = val['gradename'] + val['classname']

        })
      }
      if (url.indexOf('canteenAmountRecord/getQueryList') > -1) {
        jsonData.map(function (val, index) {
          val['afteramount'] = val['bamount'] + val['amount']

        })
      }
      if (url.indexOf('webUser/dataList?isPrincipal=-1') > -1) {
        jsonData.map(function (val, index) {
          var cList = val.cList
          val['classname'] = ''
          var html = ''
          for (var item = 0; item < cList.length; item++) {
            var itemData = cList[item];

            if (item < 5) {
              html += itemData + "、";
            }
            val['classname'] = html
          }


        })
      }
      if (url.indexOf('dailyCheckConfigPoint/queryPointData') > -1) {
        jsonData.map(function (c, index) {
          console.log(c, index, 'cindex')
          var totalnum = c.aunm + c.bunm + c.cunm
          var haduse = totalnum - c.dunm
          var str = haduse + '/' + totalnum
          c['classname'] = str



        })
      }
      if (url.indexOf('studentReview/getScoreByClass') > -1) {

        jsonData.map(function (val, index) {
          for (var key in val) {
            if (key.indexOf('%') > -1) {
              var _data = val[key]
              var _dd = key.replace(/%/g, '%25')
              var _key = decodeURIComponent(decodeURI(_dd))
              console.log(key)
              val[_key] = _data
            }

          }
        })


      }
      jsonData.map(function (val, index) {
        val['name'] = decodeURIComponent(val['name'])
      })

    } else {
      viewUI.Message.error(res.msg)
    }
  })


}



function formatJson(filterVal, jsonData) {
  return jsonData.map(v => filterVal.map(j => v[j]))
}

function checkToken() {
  var that = this
  var _tokenexprie = localStorage.getItem('expiresTo') || ''
  var username = localStorage.getItem('jwjcurUsername')
  var password = localStorage.getItem('jwjcurUserpwd')




  if (_tokenexprie != '') {

    if (CompareDate(_tokenexprie) < 2) {

      axios.post('oauth/token', {
        username: username,
        password: password,
        sms_code: '',
        grant_type: 'password',
        systemid: 'web'
      }).then(back => {

        if (back && back.data && back.data['access_token']) {
          localStorage.setItem('access_token', back.data['access_token'])
          localStorage.setItem('expiresTo', back.data['expires_to'])
        }
      })
    }


  }
}

function CompareDate(d1) {
  var myDate = new Date();
  var myYear = myDate.getFullYear();
  var myMonth = myDate.getMonth();
  var myDay = myDate.getDate();
  var d2 = myYear + "-" +
    (myMonth < 9 ? ("0" + (myMonth + 1)) : (myMonth + 1)) + "-" +
    (myDay < 10 ? ("0" + myDay) : myDay);
  d2 += ' 00:00:00'

  return getDiffDay(d1, d2)

}

function getDiffDay(date_1, date_2) {
  let totalDays, diffDate
  let myDate_1 = Date.parse(date_1)
  let myDate_2 = Date.parse(date_2)
  diffDate = Math.abs(myDate_1 - myDate_2)
  totalDays = Math.floor(diffDate / (1000 * 3600 * 24))
  return totalDays
}
export default {
  getCurDate,
  CheckImgExists,
  exportExcel,
  exportExcelPost,
  checkToken
}